import * as React from "react"

const Search = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 18.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM22 22.5 15.5 17"
    />
  </svg>
)
export default Search
